module.exports = __webpack_public_path__ + "assets/ff3531853a3899258f241c2bb444a10b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** /Users/kevinduarte/SG/roc2/plugins/slot/public-src/common/sounds/reels.mp3
 ** module id = 172
 ** module chunks = 0
 **/